/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AddPKIKeyRequest, CallerRef, InitiateOAuthResult, MapString, WrappedGrantView } from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "zoominfo";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @tags OAuth
   * @name ZoomInfoOAuthCallback
   * @request GET:/v1/public/oauth/callback
   */
  zoomInfoOAuthCallback = (
    query: {
      state: string;
      /** @pattern [^\s\\/]+ */
      code?: string;
      /** @pattern [^\s\\/]+ */
      context?: string;
      /** @minLength 1 */
      scopes?: string;
      /** @pattern [^\s\\/]+ */
      error?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for zoomInfoOAuthCallback */
  zoomInfoOAuthCallbackPathGetter = (query: {
    state: string;
    /** @pattern [^\s\\/]+ */
    code?: string;
    /** @pattern [^\s\\/]+ */
    context?: string;
    /** @minLength 1 */
    scopes?: string;
    /** @pattern [^\s\\/]+ */
    error?: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);

  /**
   * No description
   *
   * @tags OAuth
   * @name InitiateZoomInfoOAuthFlow
   * @request GET:/v1/tenant/{tenantId}/oauth/initiate
   * @secure
   */
  initiateZoomInfoOAuthFlow = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      InitiateOAuthResult,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/initiate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateZoomInfoOAuthFlow */
  initiateZoomInfoOAuthFlowPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/oauth/initiate`);

  /**
   * No description
   *
   * @tags Grants
   * @name GetZoomInfoGrantView
   * @request GET:/v1/tenant/{tenantId}/grant/organization
   * @secure
   */
  getZoomInfoGrantView = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      WrappedGrantView,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/grant/organization`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getZoomInfoGrantView */
  getZoomInfoGrantViewPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/grant/organization`);

  /**
   * No description
   *
   * @tags Grants
   * @name UpsertZoomInfoPkiKey
   * @request POST:/v1/tenant/{tenantId}/grant/organization
   * @secure
   */
  upsertZoomInfoPkiKey = (tenantId: string, data: AddPKIKeyRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/grant/organization`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertZoomInfoPkiKey */
  upsertZoomInfoPkiKeyPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/grant/organization`);

  /**
   * No description
   *
   * @tags Grants
   * @name DeleteZoomInfoGrant
   * @request DELETE:/v1/tenant/{tenantId}/grant/organization
   * @secure
   */
  deleteZoomInfoGrant = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/grant/organization`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteZoomInfoGrant */
  deleteZoomInfoGrantPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/grant/organization`);
}
